module.exports = __webpack_public_path__ + "static/media/deductibleExplain.beba5136.png";